import { SkeletonCircle } from "./SkeletonCircle";
import { SkeletonPill } from "./SkeletonPill";
import { SkeletonRectangle } from "./SkeletonRectangle";
import { SkeletonText } from "./SkeletonText";

export * from "./SkeletonCircle";
export * from "./SkeletonPill";
export * from "./SkeletonRectangle";
export * from "./SkeletonText";

export const Skeleton = Object.assign(
  {},
  {
    Circle: SkeletonCircle,
    Pill: SkeletonPill,
    Rectangle: SkeletonRectangle,
    Text: SkeletonText,
  },
);
